import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { syncTrueRoleFromRole } from "../redux/features/userSlice";

/**
 * Runs once after redux-persist rehydration so older saved sessions get `trueRole`
 * populated from `role` when missing.
 */
export default function PersistHydrationSync() {
  const dispatch = useDispatch();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    dispatch(syncTrueRoleFromRole());
  }, [dispatch]);

  return null;
}
